import { render, staticRenderFns } from "./DesktopAppBar.vue?vue&type=template&id=4b41a5d7"
import script from "./DesktopAppBar.vue?vue&type=script&lang=ts"
export * from "./DesktopAppBar.vue?vue&type=script&lang=ts"
import style0 from "./DesktopAppBar.vue?vue&type=style&index=0&id=4b41a5d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports